import React, { useState, useEffect, useRef } from "react";
import "./Header.css";
import cyclecircleLogo from "../../img/parts/Cycle-Circle-Logo-White-1.png";
import cyclecircleOrangeLogo from "../../img/parts/Cycle-Circle-Logo-Orange-1.png";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import { Link, useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import {
  setSearchTerm,
  toggleOverlay,
  selectSearchTerm,
} from "../../store/slices/headerSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../features/auth/authSlice";
import {
  fetchThroughSearchAsync,
  setSubCategories,
} from "../../features/listingPage/listingPageSlice";
import debounce from "lodash.debounce";
import { setBreadcrumb } from "../../store/slices/breadCrumbsSlice";
import { setUser } from "../../features/auth/authSlice";
import BigSearch from "./BigSearch";
import { fetchAllRecommendSearchAsync } from "../../features/search/searchSlice";
import { setSelectedSubcategory } from "../../store/slices/subCategorySlice";
import toast from "react-hot-toast";
import VerticalNavigationItems from "./VerticalNavigationItems";
import HeaderRight from "./HeaderRight";
import AnimatedSearch from "./AnimatedSearch";

function Header({ searchTerm, setSearchTerm, toggleOverlay }) {
  const logoRef = useRef(null);
  const [isOptionsVisible, setOptionsVisible] = useState(false);
  const optionsContainerRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userDetail = useSelector(selectUser);
  const bigSearchContainerRef = useRef(null);


  const [recentSearches, setRecentSearches] = useState([]);

  // Function to store recent searches in local storage
  const storeRecentSearches = (searches) => {
    const encryptedSearches = btoa(JSON.stringify(searches)); // Convert to non-readable form
    localStorage.setItem("recentSearches", encryptedSearches);
  };

  // Function to fetch recent searches from local storage
  useEffect(() => {
    const fetchRecentSearches = () => {
      try {
        const encryptedSearches = localStorage.getItem("recentSearches");
        if (!encryptedSearches) return; // No data, exit early

        const decryptedSearches = JSON.parse(atob(encryptedSearches));
        if (Array.isArray(decryptedSearches)) {
          setRecentSearches(decryptedSearches);
        }
      } catch (error) {
        // console.error("Failed to load recent searches:", error);
        // Optionally clear corrupted data to avoid future errors
        // localStorage.removeItem("recentSearches");
      }
    };

    fetchRecentSearches();
  }, []);

  const handleSearchDebounced = debounce(() => {
    if (searchTerm.trim().length > 0) {
      dispatch(fetchThroughSearchAsync(searchTerm.trim()));
      dispatch(setSubCategories(null));
      dispatch(setSelectedSubcategory(null));
      dispatch(
        setBreadcrumb({
          categoryID: 0,
          categoryName: "",
          subCategoryID: 0,
          subCategoryName: "",
          ProductID: 0,
          productName: "",
        })
      );
      navigate(`/search/${searchTerm}`);
      if (!recentSearches.includes(searchTerm)) {
        const updatedSearches = [searchTerm, ...recentSearches.slice(0, 4)]; // Limit to maximum of 4 items
        setRecentSearches(updatedSearches);
        storeRecentSearches(updatedSearches);
      }
      setSearchTerm("");
      setShowSearchInput(false);
    }
  }, 300); // Adjust the delay as needed

  const sTerm = useParams();

  useEffect(() => {
    if (sTerm.text && sTerm.text.trim().length > 0) {
      dispatch(fetchThroughSearchAsync(sTerm.text.trim()));
    }
  }, [dispatch, sTerm]);

  const handleSearch = () => {
    if (searchTerm.trim().length === 0) {
      // Show SweetAlert for empty search term
      toast.error("Empty Search Term");
      return; // Exit the function early
    }
    handleSearchDebounced();
    setShowVerticalContainer(true);
    setShowSearchInput(false);
    document.getElementById("searchInput").blur();
  };
  const handleKeyInput = (e) => {
    e.preventDefault();
    setSearchTerm(e.target.value);
    if (e.target.value === "") {
      dispatch(fetchAllRecommendSearchAsync("a"));
    } else {
      dispatch(fetchAllRecommendSearchAsync(e.target.value));
    }
  };
  useEffect(() => {
    dispatch(fetchAllRecommendSearchAsync("a"));
  }, [dispatch]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (e.target.value.trim().length === 0) {
        // Show SweetAlert for empty search term
        toast.error("Empty Search Term");
        return; // Exit the function early
      }

      // Proceed with the search
      handleSearch();
      navigate(`/search/${e.target.value.trim()}`);
      e.target.value = "";
      setShowSearchInput(false);
    }
  };
  const handleEmptyBreadcrum = () => {
    // dispatch(setBreadcrumb({
    //   categoryID: null,
    //   categoryName: "",
    //   subCategoryID: null,
    //   subCategoryName: "",
    //   ProductID: null,
    //   productName: "",
    // }));
    // navigate("/");
  };

  // Close options container when clicking outside
  const handleClickOutside = (event) => {
    if (
      optionsContainerRef.current &&
      !optionsContainerRef.current.contains(event.target)
    ) {
      setOptionsVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOptionsVisible]);

  const [showVerticalContainer, setShowVerticalContainer] = useState(true);
  const [showSearchInput, setShowSearchInput] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (showSearchInput) {
      inputRef.current.focus();
    }
  }, [showSearchInput]);

  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (
        !e.target.closest(".headers-middle-search-container") &&
        !e.target.closest(".headers-middle-search-big-search-container")
      ) {
        setShowVerticalContainer(true);
        setShowSearchInput(false);
      }
    };
    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  // Logo hover handlers
  const handleMouseEnter = () => {
    if (logoRef.current) logoRef.current.src = cyclecircleOrangeLogo;
  };
  const handleMouseLeave = () => {
    if (logoRef.current) logoRef.current.src = cyclecircleLogo;
  };


  return (
    <>
      <div className="headers-container">
        {showSearchInput && <div className="search-overlay"></div>}
        <Link
          to="/"
          onClick={handleEmptyBreadcrum}
          className="headers-left-logo-container"
        >
          <img
            loading="lazy"
            id="logoImg"
            ref={logoRef}
            src={cyclecircleLogo}
            alt="website logo"
            className="headers-left-website-logo"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          />
        </Link>
        <div className="headers-middle-vertical-and-search-container">
          {showVerticalContainer && <VerticalNavigationItems />}

          <div className="headers-middle-search-container">
            {showSearchInput && (
              <div className="headers-middle-search-main-container">
                <input
                  id="searchInput"
                  ref={inputRef}
                  type="text"
                  placeholder="Search over 3000+ products"
                  className="headers-middle-search-input"
                  value={searchTerm}
                  onChange={(e) => handleKeyInput(e)}
                  onKeyPress={handleKeyPress}
                  // onFocus={() => handleClickInput("true")}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
            )}
            <AnimatedSearch
              showSearchInput={showSearchInput}
              setShowSearchInput={setShowSearchInput}
              setShowVerticalContainer={setShowVerticalContainer}
            />
            <SearchSharpIcon
              id="headers-middle-search-icon"
              onClick={handleSearch}
            />
          </div>
          {!showSearchInput && (
            <div className="headers-join-us-container">
              {!Object.keys(userDetail).length && (
                <span
                  className="headers-join-us-btn whitespace-nowrap"
                  onClick={() => {
                    toggleOverlay();
                  }}
                >
                  Join Us
                </span>
              )}
            </div>
          )}
          {showSearchInput && (
            <div
              className="headers-middle-search-big-search-container"
              ref={bigSearchContainerRef}
            >
              <BigSearch
                searchTerm={searchTerm}
                recentSearches={recentSearches}
                storeRecentSearches={storeRecentSearches}
                setRecentSearches={setRecentSearches}
                setShowVerticalContainer={setShowVerticalContainer}
                setShowSearchInput={setShowSearchInput}
              />
            </div>
          )}
        </div>
        <HeaderRight />
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  searchTerm: selectSearchTerm(state),
  user: state.user,
});
const mapDispatchToProps = {
  setSearchTerm,
  toggleOverlay,
  setUser,
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);
